export const uiPricingPlan = {
    name: 'UI Pricing Plan',
    description: '',
    displayField: 'title',
    fields: {
        title: {
            name: 'Title',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        description: {
            name: 'Description',
            type: 'Symbol',
            required: false,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        price: {
            name: 'Price',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        priceDetails: {
            name: 'Price Details',
            type: 'Symbol',
            required: false,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        buttons: {
            name: 'Buttons',
            type: 'Link',
            linkType: 'Entry',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [{ linkContentType: ['uiLoginContainer'] }]
        },
        highlight: {
            name: 'Highlight',
            type: 'Boolean',
            required: true,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        },
        featureList: {
            name: 'Feature List',
            type: 'Text',
            required: false,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        }
    }
};
//# sourceMappingURL=uiPricingPlan.js.map